const stats = [
  { value: "10k", suffix: "+", label: "Utilisateurs actifs" },
  { value: "500", suffix: "€+", label: "Économies mensuelles moyennes" },
  { value: "98", suffix: "%", label: "Taux de satisfaction" },
  { value: "0", suffix: "€", label: "Coût d'entrée (gratuit)" },
];

export default function StatsSection() {
  return (
    <section className="py-20 md:py-28 px-6 md:px-12 bg-background-50">
      <div className="max-w-[1400px] mx-auto">
        <div className="flex flex-col lg:flex-row gap-12 md:gap-20">
          {/* Left label */}
          <div className="lg:w-44 flex-shrink-0">
            <p className="text-xs font-semibold tracking-widest text-foreground-400 uppercase font-sans">
              Données clés
            </p>
          </div>

          {/* Right content */}
          <div className="flex-1">
            <p className="text-xl md:text-2xl text-foreground-700 font-sans leading-relaxed max-w-3xl mb-16 md:mb-20">
              Le <strong className="text-foreground-950">Hipobuy Spreadsheet</strong> transforme la façon dont les particuliers gèrent leurs finances. Conçu pour offrir une expérience fluide et intuitive, ce système de suivi budgétaire s'adapte à tous les profils : étudiants, professionnels et familles. Avec une approche centrée sur la simplicité et l'efficacité, il élimine la complexité des applications financières traditionnelles tout en conservant une puissance d'analyse professionnelle. Chaque fonctionnalité a été pensée pour vous faire gagner du temps et de l'argent.
            </p>

            {/* Stats grid */}
            <div className="grid grid-cols-2 lg:grid-cols-4 gap-8 md:gap-12">
              {stats.map((stat) => (
                <div key={stat.label}>
                  <div className="flex items-baseline gap-1 mb-2">
                    <span className="text-4xl md:text-5xl lg:text-6xl font-bold text-foreground-950 font-heading">
                      {stat.value}
                    </span>
                    <span className="text-xl md:text-2xl text-foreground-400 font-heading">
                      {stat.suffix}
                    </span>
                  </div>
                  <p className="text-sm text-foreground-500 font-sans">
                    {stat.label}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}